const BASE = process.env.REACT_APP_API_URL || "https://zoommembers.com";

async function request(method, path, body) {
  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  let res;
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (networkErr) {
    throw new Error(`Network error: cannot reach ${BASE}`);
  }

  const data = await res.json().catch(() => ({}));

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    throw new Error("Session expired. Please log in again.");
  }
  if (res.status === 403) throw new Error("Access denied.");
  if (!res.ok) throw new Error(data.detail || data.error || `Request failed (${res.status})`);

  return data;
}

export const api = {
  login:  (username, password) => request("POST", "/api/login", { username, password }),
  logout: ()                   => request("POST", "/api/logout"),
  me:     ()                   => request("GET",  "/api/me"),

  summary:      ()            => request("GET", "/api/dashboard/summary"),
  events:       (limit = 100) => request("GET", `/api/events?limit=${limit}`),
  getScheduled: ()            => request("GET", "/api/scheduled"),
  getHistory:   ()            => request("GET", "/api/task_history"),

  getCampaigns:      ()          => request("GET",    "/api/campaigns"),
  createCampaign:    (body)      => request("POST",   "/api/campaigns", body),
  getCampaign:       (id)        => request("GET",    `/api/campaigns/${id}`),
  startCampaign:     (id)        => request("POST",   `/api/campaigns/${id}/start`),
  stopCampaign:      (id)        => request("POST",   `/api/campaigns/${id}/stop`),
  forceExitCampaign: (id)        => request("POST",   `/api/campaigns/${id}/force_exit`),
  sendReaction:      (id, emoji) => request("POST",   `/api/campaigns/${id}/reaction`, { emoji }),
  deleteCampaign:    (id)        => request("DELETE", `/api/campaigns/${id}`),
  cancelScheduled:   (tid)       => request("POST",   `/api/campaigns/scheduled/${tid}/cancel`),
  refillHistory:     (hid)       => request("POST",   `/api/campaigns/history/${hid}/refill`),

  getAgents:     ()         => request("GET",    "/api/agents"),
  createAgent:   (body)     => request("POST",   "/api/agents", body),
  updateAgent:   (id, body) => request("PATCH",  `/api/agents/${id}`, body),
  regenAgentKey: (id)       => request("POST",   `/api/agents/${id}/regenerate_key`),
  deleteAgent:   (id)       => request("DELETE", `/api/agents/${id}`),

  getBots:  (campaignId) => request("GET", `/api/bots?campaign_id=${campaignId}`),
  botStats: ()           => request("GET", "/api/bots/stats"),

  adminGetUsers:       ()          => request("GET",    "/api/admin/users"),
  adminCreateUser:     (body)      => request("POST",   "/api/admin/users", body),
  adminUpdateUser:     (id, body)  => request("PATCH",  `/api/admin/users/${id}`, body),
  adminDeleteUser:     (id)        => request("DELETE", `/api/admin/users/${id}`),
  adminGetHistory:     (limit=200) => request("GET",    `/api/admin/login_history?limit=${limit}`),
  adminGetUserHistory: (uid)       => request("GET",    `/api/admin/login_history/${uid}`),
  adminClearHistory:   ()          => request("DELETE", "/api/admin/login_history"),
  adminAddFund:        (id, body)  => request("POST",   `/api/admin/users/${id}/add_fund`, body),
  adminGetFundHistory: (id)        => request("GET",    `/api/admin/users/${id}/fund_history`),
  adminDeductFund:     (id, body)  => request("POST",   `/api/admin/users/${id}/deduct_fund`, body),
};